import { MantineSize } from '@mantine/core';
import { Badge } from 'src/design/atoms/Badge';
import React from 'react';

export interface IScaleBadgeProps {
  isScale?: boolean;
  bypassScalePay?: boolean;
  isDirect?: boolean;
  scalePayAdjustmentAmount?: number;
  size?: MantineSize;
}

/**
 * @registry "Scale" badge shown on a timesheet row when scale pay actually applies (isScale, not bypassed, direct pay code, positive adjustment).
 */
export const ScaleBadge: React.FC<IScaleBadgeProps> = ({
  isScale,
  bypassScalePay,
  isDirect,
  scalePayAdjustmentAmount,
  size = 'xs',
}) => {
  if (!isScale) return null;
  if (bypassScalePay) return null;
  if (isDirect === false) return null;
  if (scalePayAdjustmentAmount !== undefined && scalePayAdjustmentAmount <= 0)
    return null;

  return (
    <Badge color="blue" variant="light" size={size}>
      Scale
    </Badge>
  );
};
